import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { AbstractButtonComponent } from '../abstract-button.component';

/**
 * Similar to swatch but presents checkbox icon instead
 */

export type TIconButton = 'default' | 'filled' | 'filled-dark';
@Component({
    selector: 'button[iconButton], a[iconButton]',
    templateUrl: './icon-button.html',
    styleUrls: ['./icon-button.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class IconButtonComponent extends AbstractButtonComponent {
    @Input()
    iconButton: TIconButton | undefined | '' = 'default';

    @HostBinding('class._animated-text')
    @Input()
    textAnimated?: string;

    protected variantInputName = 'iconButton';
}
